// import Slider
import SnapSlider from '@tannerhodges/snap-slider';

// Initialize Slider
function DOMReady(callback)
{
    return document.readyState === "interactive" || document.readyState === "complete" ? callback() : document.addEventListener("DOMContentLoaded", callback)
}

DOMReady(() => {
    const sliderElements = document.querySelectorAll('[data-snap-slider^="collection"]')
    let sliders = [];
    sliderElements.forEach(sliderElement => {
        sliders.push(new SnapSlider(sliderElement));
        sliderElement.addEventListener('focusin', function (event) {
            event.stopImmediatePropagation()
        }, true)
    })
})